import { IStores } from "./index";
import * as services from "services";
import { ListStoreConstructor } from "./ListStoreConstructor";
import { FiatCurrencyGridDto } from "interfaces";

export class FiatCurrencyList extends ListStoreConstructor<FiatCurrencyGridDto> {
    currencyList: FiatCurrencyGridDto[] = [];
    currencyMap: { [key: string]: string } = {};

  constructor(stores: IStores) {
    super(
      stores,
      (params) => {
        return services.getFiatCurrencyList(params).then((response) => {
          this.currencyList = response.content || [];
          this.currencyMap = this.currencyList.reduce((acc, currency) => {
            acc[currency.isoLat3] = currency.nameRus;
            return acc;
          }, {} as { [key: string]: string });
          
          return {
            content: response.content || [],
            size: response.size || 0,
            totalPages: response.totalPages || 0,
            totalElements: response.totalElements || 0,
          };
        });
      },
      {
        pollingInterval: 0,
        paginationData: {
          pageSize: 1000,
        },
      }
    );
  }
}
